import React from 'react'
import { useI18n } from '../../i18n'

/**
 * Закреплённая нижняя панель с кнопкой «Сохранить».
 * Используется на всех страницах настроек конфигурации.
 */
export default function SettingsSavePanel({ onSave, saving, dirty }) {
  const { t } = useI18n()
  return (
    <div className="settings-save-panel">
      <button
        type="button"
        className="btn btn-primary"
        onClick={onSave}
        disabled={saving || !dirty}
      >
        {saving ? t('common.saving') : t('common.save')}
      </button>
    </div>
  )
}
